/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ClassCapacityRow
 */
export interface ClassCapacityRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassCapacityRow
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassCapacityRow
     */
    enrolled: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassCapacityRow
     */
    capacity: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof ClassCapacityRow
     */
    utilizationPercent: number;
}

/**
 * Check if a given object implements the ClassCapacityRow interface.
 */
export function instanceOfClassCapacityRow(value: object): value is ClassCapacityRow {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('enrolled' in value) || value['enrolled'] === undefined) return false;
    if (!('capacity' in value) || value['capacity'] === undefined) return false;
    if (!('utilizationPercent' in value) || value['utilizationPercent'] === undefined) return false;
    return true;
}

export function ClassCapacityRowFromJSON(json: any): ClassCapacityRow {
    return ClassCapacityRowFromJSONTyped(json, false);
}

export function ClassCapacityRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassCapacityRow {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'enrolled': ApiUserTasksGetPageParameterFromJSON(json['enrolled']),
        'capacity': ApiUserTasksGetPageParameterFromJSON(json['capacity']),
        'utilizationPercent': json['utilizationPercent'],
    };
}

export function ClassCapacityRowToJSON(json: any): ClassCapacityRow {
    return ClassCapacityRowToJSONTyped(json, false);
}

export function ClassCapacityRowToJSONTyped(value?: ClassCapacityRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'enrolled': ApiUserTasksGetPageParameterToJSON(value['enrolled']),
        'capacity': ApiUserTasksGetPageParameterToJSON(value['capacity']),
        'utilizationPercent': value['utilizationPercent'],
    };
}

